export const DEALTAG_LOADING = "DEALTAG_LOADING";
export const DEALTAG_RESET = "DEALTAG_RESET";
export const GET_DEALTAG = "GET_DEALTAG";
export const GET_DEALTAG_SUCCESS = "GET_DEALTAG_SUCCESS";
export const GET_DEALTAG_FAIL = "GET_DEALTAG_FAIL";
export const DELETE_DEALTAG = "DELETE_DEALTAG";
export const DELETE_DEALTAG_SUCCESS = "DELETE_DEALTAG_SUCCESS";
export const DELETE_DEALTAG_FAIL = "DELETE_DEALTAG_FAIL";
export const UPDATE_DEALTAG = "UPDATE_DEALTAG";
export const UPDATE_DEALTAG_SUCCESS = "UPDATE_DEALTAG_SUCCESS";
export const UPDATE_DEALTAG_FAIL = "UPDATE_DEALTAG_FAIL";
export const ADD_NEW_DEALTAG = "ADD_NEW_DEALTAG";
export const ADD_DEALTAG_SUCCESS = "ADD_DEALTAG_SUCCESS";
export const ADD_DEALTAG_FAIL = "ADD_DEALTAG_FAIL";
